/** @jsx jsx */
import { memo } from 'react';
import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@atlaskit/css';
import { SimpleTag } from '@atlaskit/tag';

type Props = {
	labels: string[];
};

export const CardLabels = ({ labels }: Props) => {
	return (
		<div css={styles.root}>
			{labels.map((label) => (
				<SimpleTag key={label} text={label} />
			))}
		</div>
	);
};

export default memo(CardLabels);

const styles = cssMap({
	root: {
		display: 'flex',
		alignItems: 'center',
		flexFlow: 'row wrap',
		marginTop: token('space.negative.050'),
		marginRight: token('space.negative.050'),
		marginBottom: token('space.negative.050'),
		marginLeft: token('space.negative.050'),
		width: '100%',
	},
});
